import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index';
import 'flatpickr/dist/plugins/monthSelect/style.css';

const MonthPickerHook = {
  mounted() {
    const defaultMonth = this.el.dataset.defaultMonth;
    const maxMonth = this.el.dataset.maxMonth; 
    
    let defaultDate = null;
    if (defaultMonth) {
      const [year, month] = defaultMonth.split('-');
      defaultDate = new Date(parseInt(year), parseInt(month) - 1, 1);
    }
    
    let maxDate = null;
    if (maxMonth) {
      const [maxYear, maxMonthNum] = maxMonth.split('-');
      maxDate = new Date(parseInt(maxYear), parseInt(maxMonthNum) - 1, 1);
    }
    
    const config = {
      plugins: [
        new monthSelectPlugin({
          shorthand: true,
          dateFormat: 'M Y',
          altFormat: 'M Y'
        })
      ],
      defaultDate: defaultDate,
      disableMobile: true,
      onChange: (selectedDates, dateStr, instance) => {
        if (selectedDates.length > 0) {
          const date = selectedDates[0];
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const serverFormat = `${year}-${month}`;
          
          this.pushEvent("change_month", { month: serverFormat });
        }
      }
    };
    
    if (maxDate) {
      config.maxDate = maxDate;
    }
    
    this.picker = flatpickr(this.el, config);
  },
  
  updated() {
    const defaultMonth = this.el.dataset.defaultMonth;
    if (this.picker && defaultMonth) {
      const [year, month] = defaultMonth.split('-');
      const date = new Date(parseInt(year), parseInt(month) - 1, 1);
      this.picker.setDate(date, false);
    }
  },
  
  destroyed() {
    if (this.picker) {
      this.picker.destroy();
    }
  }
};

export default MonthPickerHook;